<template>
  <ContentDetails />
</template>

<script setup lang="ts">
import { ContentDetails } from '~/pages/_components/content-details';
</script>
